<div [ngClass]="{ 'highlight-border': true }" *ngIf="highlightId">
  <ng-content></ng-content>
</div>
